import { IBuyer } from "../types/data.interface";

export const formatBuyerIntoOption = (item: IBuyer) => ({
  value: item,
  label: `${item.name}`,
});

export const getBuyers = (buyers: IBuyer[]) =>
  buyers.map(formatBuyerIntoOption);
